import { createI18n } from "vue-i18n";
import ua from "./locales/ua.json";
import en from "./locales/en.json";

// localStorage може бути недоступним (тести в node-оточенні, заборонене сховище браузера)
function readStorage(key: string): string | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // мова лишиться активною до перезавантаження сторінки
  }
}

// Function to get language key for current user
function getLanguageKey(): string {
  const userEmail = readStorage("userEmail");
  return userEmail ? `language_${userEmail}` : "language";
}

// Get saved language from localStorage or default to 'ua'
const savedLang =
  readStorage(getLanguageKey()) || readStorage("language") || "ua";

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: savedLang,
  fallbackLocale: "ua",
  messages: {
    ua,
    en,
  },
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  // Довідка Anchor Plan зберігає статичну розмітку в перекладах (без даних користувача)
  warnHtmlMessage: false,
});

export default i18n;

// Helper function to save language preference
export function setLanguage(lang: string) {
  i18n.global.locale.value = lang as typeof i18n.global.locale.value;
  // Save for current user
  writeStorage(getLanguageKey(), lang);
  // Also save global fallback
  writeStorage("language", lang);
}

// Helper function to get current language
export function getLanguage() {
  return i18n.global.locale.value;
}

/** Локаль для Intl.NumberFormat / Intl.DateTimeFormat під мову інтерфейсу. */
export function intlLocale(lang: string = getLanguage()): string {
  return lang === "en" ? "en-US" : "uk-UA";
}

/** Мова для заголовка Accept-Language запитів до API. */
export function apiLanguage(lang: string = getLanguage()): string {
  return lang === "en" ? "en" : "uk";
}
